import { render, staticRenderFns } from "./AcademyPage.vue?vue&type=template&id=3c19573f&scoped=true"
import script from "./AcademyPage.vue?vue&type=script&lang=js"
export * from "./AcademyPage.vue?vue&type=script&lang=js"
import style0 from "./AcademyPage.vue?vue&type=style&index=0&id=3c19573f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c19573f",
  null
  
)

export default component.exports